import request from '@/utils/requestUtil'

// 个人待评价列表
export function waitComment(params) {
  return request({
    url: '/comment/waitComment',
    method: 'get',
    params
  })
}

// 个人已评价列表
export function commentedList(params) {
  return request({
    url: '/comment/commentedList',
    method: 'get',
    params
  })
}

// 用户提交评价
export function comment(data) {
  return request({
    url: '/comment',
    method: 'post',
    data
  })
}

// 商品详情页-评价列表
export function productComment(params) {
  return request({
    url: '/comment/productComment',
    method: 'get',
    params
  })
}

// 待评价的商品sku详情
export function commentItemDetail(params) {
  return request({
    url: '/comment/itemDetail',
    method: 'get',
    params
  })
}
